<ng-template #addPortfolioModal let-c="close" let-d="dismiss">
  <form #addPortfolioForm="ngForm" [class.submitted]="addPortfolioForm.submitted"
        (ngSubmit)="createRecord(addPortfolioForm)" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">Add Portfolio</h4>
      <button type="button" class="btn btn-close" aria-label="Close" (click)="d()"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="name" class="text-uppercase">{{"FORMS.FULL_NAME" | translate}}:
              <rms-required-label [componentForm]="addPortfolioForm" [formFieldReference]="nameRef"></rms-required-label>
            </label>
            <input type="text" id="name" name="name" [(ngModel)]="name" #nameRef="ngModel" class="form-control" required>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="portfolioType" class="text-uppercase">
              Portfolio Type:
              <rms-required-label [componentForm]="addPortfolioForm" [formFieldReference]="portfolioTypeRef"></rms-required-label>
            </label>
            <select class="form-control" name="portfolioType" id="portfolioType"
                    [(ngModel)]="portfolioType" #portfolioTypeRef="ngModel" required>
              <option [value]="STANDARD">Standard</option>
              <option [value]="VENTURE">Venture</option>
              <option [value]="SLEEVE">Sleeve</option>
            </select>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="tenantId" class="text-uppercase">
              {{"GENERICS.TENANT" | translate}}:
              <rms-required-label [componentForm]="addPortfolioForm" [formFieldReference]="tenantIdRef"></rms-required-label>
            </label>
            <select class="form-control" name="tenantId" id="tenantId"
                    [(ngModel)]="tenantId" #tenantIdRef="ngModel" required>
              <option *ngFor="let item of tenantList?.records" [value]="item.id">{{item.name}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="c()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary">CREATE PORTFOLIO</button>
    </div>
  </form>
</ng-template>
